import utils from "../../../utils/utils";
import { DEFAULT_PRESETS } from "../../common/DateRangeFilter";
import { resolveVaultDocumentStage } from "./qmsVaultUtils";

export const DOCUMENT_CONTROL_EMPTY_DATE_RANGE = {
  preset: "All Time",
  startDate: "",
  endDate: "",
};

export const DOCUMENT_CONTROL_COLUMN_DATE_PRESETS = DEFAULT_PRESETS;

export function createInitialDocumentControlFilters() {
  return {
    typeAbbrs: [],
    categoryAbbrs: [],
    controlStatuses: [],
    stages: [],
    publishedDateRange: { ...DOCUMENT_CONTROL_EMPTY_DATE_RANGE },
    updatedDateRange: { ...DOCUMENT_CONTROL_EMPTY_DATE_RANGE },
  };
}

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}

function endOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}

function matchesDateRange(value, range) {
  if (!range || range.preset === "All Time" || (!range.startDate && !range.endDate)) {
    return true;
  }
  const raw = String(value ?? "").trim();
  if (!raw || raw.toUpperCase() === "N/A") return false;

  const date = utils.parseDateInput(raw);
  if (!date) return false;

  const start = range.startDate ? startOfDay(utils.parseDateInput(range.startDate)) : null;
  const end = range.endDate ? endOfDay(utils.parseDateInput(range.endDate)) : null;

  if (start && date < start) return false;
  if (end && date > end) return false;
  return true;
}

function rowTypeAbbr(row) {
  return String(row?.DocumentTypeAbberiviation || "").trim();
}

function rowCategoryAbbr(row) {
  return String(
    row?.DocumentCategoryAbberiviation || row?.DocumentCategoryAbbreviation || "",
  ).trim();
}

export function applyDocumentControlFilters(rows, filters) {
  if (!filters) return rows || [];

  return (rows || []).filter((row) => {
    if (filters.typeAbbrs?.length && !filters.typeAbbrs.includes(rowTypeAbbr(row))) {
      return false;
    }
    if (filters.categoryAbbrs?.length && !filters.categoryAbbrs.includes(rowCategoryAbbr(row))) {
      return false;
    }
    if (filters.controlStatuses?.length) {
      const status = String(row?.ControlStatus || "").trim().toLowerCase();
      if (!filters.controlStatuses.some((item) => String(item).trim().toLowerCase() === status)) {
        return false;
      }
    }
    if (filters.stages?.length) {
      const stage = resolveVaultDocumentStage(row?.DocumentStage).toLowerCase();
      if (!filters.stages.some((item) => String(item).trim().toLowerCase() === stage)) {
        return false;
      }
    }
    if (!matchesDateRange(row?.PublishedDate, filters.publishedDateRange)) return false;
    if (!matchesDateRange(row?.SystemDateTime, filters.updatedDateRange)) return false;
    return true;
  });
}

export function buildDocumentControlStageOptions(rows) {
  const values = new Set();
  (rows || []).forEach((row) => {
    values.add(resolveVaultDocumentStage(row?.DocumentStage));
  });
  return [...values]
    .sort((a, b) => a.localeCompare(b))
    .map((value) => ({ value, label: value }));
}

export function buildDocumentControlStatusOptions(rows) {
  const values = new Set();
  (rows || []).forEach((row) => {
    const status = String(row?.ControlStatus || "").trim();
    if (status) values.add(status);
  });
  return [...values]
    .sort((a, b) => a.localeCompare(b))
    .map((value) => ({ value, label: value }));
}

export function mapDocumentControlLookupOptions(items) {
  return (items || []).map((item) => ({
    value: item.abbr || item.id,
    label: item.abbr && item.label ? `${item.abbr} - ${item.label}` : item.label || item.abbr,
  }));
}
